import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import EfUserStoriesYoutubeAuthor from 'elem/ui/ef-user-stories-youtube-author';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();

    const lists = [
        {
            title: `EcoFlow DELTA 2 Max | Finally, a Lightweight & Compact Lithium Power Station!`,
            text: `EcoFlow DELTA 2 Max | Finally, a Lightweight & Compact Lithium Power Station!`,
            link: 'https://www.youtube.com/embed/rmZtLu9YZf4',
            imgPC: 'https://i.ytimg.com/vi/rmZtLu9YZf4/maxresdefault.jpg',
            avatar: 'https://yt3.ggpht.com/Sr5Cj_IKywZZejDt2OggDaHBLp_5MkSodJhtUjgLNbxgJjho3Cir-ZDtecUZSGXWa352nnujFD4=s48-c-k-c0x00ffffff-no-rj',
            author: 'Explore Bound',
        },
        {
            title: 'EcoFlow - Is It WORTH It? Can It EXPAND Our Battery System?',
            text: 'EcoFlow - Is It WORTH It? Can It EXPAND Our Battery System?',
            link: 'https://www.youtube.com/embed/ZiSdr0IEEyg',
            imgPC: 'https://i.ytimg.com/vi/ZiSdr0IEEyg/maxresdefault.jpg',
            avatar: 'https://yt3.ggpht.com/kcCYwWlQ5E5pNui2jHSmnelVBl-qGKMrvco9-78zg9-BKystHMq1L4XTc5Tmzo9LPdNvXaLpzg=s48-c-k-c0x00ffffff-no-rj',
            author: `Five Down Under - Travelling Australia`,
        },
        {
            title: 'Power Your Ham Radio Anywhere with EcoFlow DELTA 2',
            text: 'Power Your Ham Radio Anywhere with EcoFlow DELTA 2',
            link: 'https://www.youtube.com/embed/D-gvPrlLRXc',
            imgPC: 'https://i.ytimg.com/vi/D-gvPrlLRXc/maxresdefault.jpg',
            avatar: 'https://yt3.ggpht.com/ytc/AIdro_nGgyDLVC4oyj6qCQlTB0vsw_84nIkpW-lMwy8a-NAIug=s48-c-k-c0x00ffffff-no-rj',
            author: 'Ham Radio DX',
        },
        {
            title: 'Ecoflow Delta 2 And Next Gen 220 Watt Solar Panel',
            text: 'Ecoflow Delta 2 And Next Gen 220 Watt Solar Panel',
            link: 'https://www.youtube.com/embed/vtEIeSJ8UWY?si=7JmpxxzWmdYmezxA',
            imgPC: 'https://i.ytimg.com/vi/vtEIeSJ8UWY/maxresdefault.jpg',
            avatar: 'https://yt3.ggpht.com/ytc/AIdro_mTStZxFZ59rOCLZXIa79xy7JEgJqt7Gjx2zVKArcUZ7Pk=s48-c-k-c0x00ffffff-no-rj',
            author: 'robbiefishing',
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfUserStoriesYoutubeAuthor lists={lists} title={t('K_title')} gtm_position={t('K_title')} scrollbar={true} />
        </div>
    );
}
